import { QtmHeaderBrand, QtmTypography } from "@qtm/react";
import clsx from "clsx";

import { useNavigate } from "react-router-dom";

import "./BrandHeader.css";

const appName = import.meta.env.VITE_APP_NAME;

const BrandHeader = () => {
  const navigate = useNavigate();

  const onClick = () => {
    navigate("/");
  };

  return (
    <QtmHeaderBrand className="brand-header" onClick={onClick}>
      <img alt="thales logo" src="/logo_dark.svg" />
      <QtmTypography classes={clsx("pl-m font-bold")}>
        {appName}
      </QtmTypography>
    </QtmHeaderBrand>
  );
};

export default BrandHeader;
